export default "__VITE_ASSET__08cb1b6e__"